module.exports = __webpack_public_path__ + "static/img/sl02.5173fdd03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl02.png
// module id = pKPk
// module chunks = 0